import { render, staticRenderFns } from "./pay_success.vue?vue&type=template&id=3b8a8674&scoped=true&"
import script from "./pay_success.vue?vue&type=script&lang=js&"
export * from "./pay_success.vue?vue&type=script&lang=js&"
import style0 from "./pay_success.vue?vue&type=style&index=0&id=3b8a8674&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8a8674",
  null
  
)

export default component.exports